// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;(function ( $, window, document, undefined ) {

  // Create the defaults once
  var pluginName = 'checkGroupComposition';
  var defaults = {
    maxCount: 21
  };

  // The actual plugin constructor
  function Plugin(element, options) {
    this.$element = $(element);

    this.options = $.extend( {}, defaults, options );

    this.$adultsElement = this.$element.find('select[name=form-pref-numberofadults]');
    this.$childrenElement = this.$element.find('select[name=form-pref-numberofchildren]');
    this.$babiesElement = this.$element.find('select[name=form-pref-numberofbabies]');
    this.$buttonElement = this.$element.find('.btn').not('.dont-hide');
    this.$CompositionButtonElement = this.$element.find('.group-composition-button');
    this.$groupElement = this.$element.find('.group-composition-too-large');

    this._defaults = defaults;
    this._name = pluginName;

    this.init();
  }

  Plugin.prototype = {
    init: function() {
      this.addEventListeners();

      this.$adultsElement.trigger('change');
    },

    // Add event listeners
    addEventListeners: function () {
      this.$adultsElement.on('change', $.proxy(this, 'checkGroupInput'));
      this.$childrenElement.on('change', $.proxy(this, 'checkGroupInput'));
      this.$CompositionButtonElement.on('click', $.proxy(this, 'submitComposition'));
    },

    // Check both input fields for combined larger than 20 persons
    checkGroupInput: function(event) {
      var count = parseInt(this.$adultsElement.val()) + parseInt(this.$childrenElement.val());
      if (count < defaults.maxCount) {
        if (this.$buttonElement.hasClass('btn--disabled')) {
          this.$buttonElement.removeClass('btn--disabled');
          this.$groupElement.addClass('hide');
          $('#js-quickbooking-submit').prop('disabled', false);
        }
      } else {
        if (this.$groupElement.hasClass('hide')) {
          this.$groupElement.removeClass('hide');
          this.$buttonElement.addClass('btn--disabled');
          $('#js-quickbooking-submit').prop('disabled', true);
        }
      }
    },

    submitComposition: function(event) {
      event.preventDefault();

      $('#form-pref-numberofadults').val(this.$adultsElement.val()).prop('selected', true);
      $('#form-pref-numberofadults').next().html(this.$adultsElement.val())
      $('#form-pref-numberofchildren').val(this.$childrenElement.val()).prop('selected', true);
      $('#form-pref-numberofchildren').next().html(this.$childrenElement.val())
      $('#form-pref-numberofbabies').val(this.$babiesElement.val()).prop('selected', true);
      $('#form-pref-numberofbabies').next().html(this.$babiesElement.val())
      $('#quickbooking-preferences').submit();
    }
  };

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function ( options ) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin( this, options ));
      }
    });
  };

})( jQuery, window, document );
